import { render } from "./ScrollToTopComponent.vue?vue&type=template&id=e9e8dcc4&ts=true"
import script from "./ScrollToTopComponent.vue?vue&type=script&lang=ts"
export * from "./ScrollToTopComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__